import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateModule, updatePage, addPageToBreadCrumbs } from 'actions/siteTracking';
import Modal from 'sub_components/Common/PortalModalNew';
import { ActionButton } from 'styled_components/Common/ActionButton';
import { CogSVG } from 'styled_components/SVG/CogSVG';
import IssueRequestWizard from './Components/IssueRequestWizard';

class IssueRequest extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
		};
	}

	onClick = id => {
		const { showModal } = this.state;
		const element = document.getElementById(id);
		element.classList.toggle('active');
		document.getElementById(`${id}trans2`).beginElement();
		if (document.getElementById(`${id}trans3`)) {
			document.getElementById(`${id}trans3`).beginElement();
			setTimeout(() => this.setState({ showModal: !showModal }), 500);
		}
	};
	onClose = id => {
		const { showModal } = this.state;
		try {
			const cancelButton = document.getElementById('cancel-button-swipe');
			if (cancelButton) {
				cancelButton.classList.add('active');
				cancelButton.innerHTML = "<span class='title'>CANCELLED</span>";
				setTimeout(() => {
					const element = document.getElementById(id);
					if (element) {
						element.classList.toggle('active');
					}
					this.setState({ showModal: !showModal });
				}, 1000);
			} else {
				setTimeout(() => {
					this.setState({ showModal: !showModal });
				}, 1000);
			}
		} catch (e) {
			console.log(e);
			setTimeout(() => {
				this.setState({ showModal: !showModal });
			}, 1000);
		}
	};

	transitionImageOver = id => {
		const isIE = /*@cc_on!@*/ false || !!document.documentMode;
		// Edge 20+
		const isEdge = !isIE && !!window.StyleMedia;
		const windows = isIE || isEdge;
		if (windows) {
			document.getElementById('issue-request-component-wrapper').classList.add('windows');
		} else {
			document.getElementById(`${id}trans1`).beginElement();
		}
	};

	render() {
		const { breakpoint, navigate, pages, location, ticketType, updateTickets } = this.props;
		const { showModal } = this.state;

		return (
			<div className='issue-request-component-wrapper' id='issue-request-component-wrapper'>
				<ActionButton
					cypressId='issue-request-component'
					module='support'
					className=''
					id='special-id-2'
					onMouseOver={() => this.transitionImageOver('special-id-2')}
					onClick={() => this.onClick('special-id-2')}
				>
					<CogSVG id='special-id-2' />
				</ActionButton>
				{showModal && (
					<Modal>
						<IssueRequestWizard
							closeModal={() => this.onClose('special-id-2')}
							breakpoint={breakpoint}
							navigate={navigate}
							pages={pages}
							location={location}
							ticketType={ticketType}
							updateTickets={updateTickets}
						/>
					</Modal>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		site: state.site_tracking,
		auth_status: state.auth_status,
		company_info: state.company_info,
	};
}

export default connect(mapStateToProps, { updateModule, updatePage, addPageToBreadCrumbs })(
	IssueRequest,
);
